/**
 * Top level customer object model
 */
const mapValues = require('lodash/mapValues');

const yup = require('yup');

const {
  requiredString,
  optionalString,
  requiredNumber,
  requiredObject,
  optionalObject,
  requiredBool,
  lazy,
  validateObject,
  arrayOf,
  optionalNumber
} = require('../utils');

const {
  addressSchema,
  attributeSchema,
  attributesSchema,
  businessHoursSchema
} = require('../common');

const {
  SCHEMA: authedUserSchema
} = require('../authedUser'); // const { ContactTypes, WellTypes } = require('../enums');


const COLLECTION = 'locations';
const SCHEMA = yup.object().shape({
  active: requiredBool().default(false),
  name: requiredString().max(200),
  address: addressSchema(false),
  phoneNumber: requiredString().max(50),
  numberOfChairs: requiredNumber().default(1),
  description: optionalString().max(2500),
  emailAddress: optionalString().email(),
  faxNumber: optionalString().max(50),
  url: optionalString().url("Please enter a valid url, e.g. \"https://yoursite.com\""),
  attributes: attributesSchema(),
  isPreferred: requiredBool().default(false),
  isMember: requiredBool().default(false),
  orgId: optionalString().nullable(),
  addedBy: authedUserSchema,
  google_street_view_image: optionalString(),
  businessHours: businessHoursSchema(),
  // facebookPageId: optionalString().max(100),
  facebookPageId: optionalString().max(1000),
  twitterHandle: optionalString().max(100),
  languagesSpoken: optionalString(),
  temporarily_closed: requiredBool().default(false),
  temporarily_closed_reason: optionalString(),
  photos: arrayOf(optionalString()),
  latitude: requiredNumber(),
  longitude: requiredNumber(),
  bulkUploadId: optionalString(),
  users: arrayOf(requiredString()),
  blacklistDomains: arrayOf(requiredString()),
  covid_verified: requiredBool().default(false) // KBM - if/when we decide to move these up to location object
  // acceptedHealthPlans: attributeSchema(),
  // acceptsPatientsfromOutsideDoctors: attributeSchema(),
  // amenities: attributeSchema(),
  // facilityType: attributeSchema(),
  // medicationsAvailable: attributeSchema(),
  // practiceSpecialty: attributeSchema(),
  // practiceType: attributeSchema(),
  // staffing: attributeSchema()

});
/**
 * This object defines custom queries to perform on the data, outside of the normal CRUD operations
 */

const QUERIES = {
  getCovidLocations: (attributeId = "ed8a0853", optionId = "covid1") => {
    return {
      where: [`attributes.${attributeId}.choice`, "array-contains", optionId],
      oderBy: ["name", "asc"]
    };
  },
  getByOrgId: orgIds => {
    return {
      where: ["orgId", "in", orgIds],
      orderBy: ["name", "asc"]
    };
  }
};
/**
 * Methods added here will trigger https-callable Cloud Functions
 */

const CALLABLES = {};
/**
 * Methods added here will be appended to each returned document from the collection
 */

const MIXINS = {};
/**
 * Dates are a bit of a pitd with Firestore, so implement this method to convert any timestamp fields to JS Date objects
 * when records are inflated from Firestore, since ultimately we need to pass Date objects back to Firestore when saving
 * records
 * @param model The inflated object from Firestore
 * @returns the model with the appropriate Timestamps converted to JS Dates
 */

const convertDates = model => {
  return model;
};

async function validate(location) {
  return validateObject(SCHEMA, location);
}

module.exports = {
  COLLECTION,
  SCHEMA,
  validate,
  QUERIES,
  CALLABLES,
  MIXINS,
  convertDates
};